<div class="row">
  <div
    class="col-md-3 d-sm-block"
    style="background-color: rgb(230, 230, 230)"
  ></div>
  <div class="col-md-auto col-sm-12" style="padding: 0 !important">
    <div class="container-fluid d-flex flex-column min-vh-100">
      <div class="balance p-4 mt-auto mb-7">
        <app-balance></app-balance>
      </div>

      <div class="fixed-bottom-sheet mt-auto">
        <div class="fixed-bottom-sheet-header">
          <app-carousel-buttons></app-carousel-buttons>
        </div>
        <div class="fixed-bottom-sheet-body">
          <app-transactions></app-transactions>
        </div>
      </div>
    </div>
  </div>
  <div
    class="col-md-3 d-sm-block"
    style="background-color: rgb(230, 230, 230)"
  ></div>
</div>
